import slice from './tilesSlice';

export const { populateTiles, resetTiles, deleteTile, addTile, updateTile } =
  slice.actions;

export default slice.reducer;
